export default {
    "our_services": "Onze diensten",
    "services_text_1": "Onze incubator bestaat uit 11 kantoren van verschillende groottes, een grote vergaderzaal, een koffiehoek en printfaciliteiten. We hebben toiletfaciliteiten op elke verdieping en twee douches op de begane grond.",
    "services_text_2": "We bieden startups kantoorruimte, mentorschap, financieel en juridisch advies en maandelijkse netwerkevenementen. Ons doel is om deze bedrijven te helpen bloeien door de ondersteuning en middelen te bieden die ze nodig hebben om te groeien.",
    "inquire_now": "Informeer nu"
}
